import { takeLatest, fork, put, call } from 'redux-saga/effects'
import { showSpinner, hideSpinner } from '../global/actions'
import { ApiRequest } from '../../utils/api';
import { doCallApi } from '../global/sagas'
import { ORDER_SUBSCRIPTIONS } from './constants';
import { orderSubscriptionsFinished } from './actions'
import { getAccountId } from '../../utils/helpers';

function* doOrderNewSubscriptions(action) {
  yield put(showSpinner());
  yield call(doCallApi, true, ApiRequest.orderSubscriptions, getAccountId(), action.payload);
  yield put(orderSubscriptionsFinished());
  yield put(hideSpinner());
}

export function* root() {
  yield fork(takeLatest, ORDER_SUBSCRIPTIONS, doOrderNewSubscriptions);
}

export default [
  root,
];
